	<p-table #dt [(selection)]="selectedProds" dataKey="Id"  *ngIf="api.games && games"  [value]="games" responsiveLayout="scroll" styleClass="p-datatable-gridlines p-datatable-sm" [scrollable]="true" scrollHeight="flex" scrollDirection="both" [paginator]="true" [rows]="50" rowGroupMode="rowspan" 
    groupRowsBy="groupField" >
		<ng-template pTemplate="header">
			<tr>
				<th>Offre / Éditeur</th>
				<th>EAN</th>
				<!-- <th pSortableColumn="Id" style="width: 200px;">Référence <p-sortIcon field="Id"></p-sortIcon></th>
				<th style="width: 250px;" pSortableColumn="name">Nom <p-sortIcon field="name"></p-sortIcon></th>
				<th style="width: 250px;" pSortableColumn="name_editor">Éditeur <p-sortIcon field="name_editor"></p-sortIcon></th>
 				-->			
				<th  style="width: 200px;">Référence</th>
 				<th style="width: 250px;">Nom </th>
				<th >Éditeur </th>
				<th style="width: 100px;">Prix brut</th>
				<th style="width: 100px;">Prix net</th>
				<th style="width: 100px;">TVA</th>
				<th *ngIf="api.adminOrder">Stock</th>
				<th *ngIf="api.adminOrder">Colisage</th>
				<th style="width: 130px"></th>
			</tr>
			<tr>
				<th>
					<p-multiSelect [options]="api.editors"  placeholder="Filtrer par éditeur" (onChange)="dt.filter($event.value,'ptt_to_editor', 'in')" optionLabel="name" appendTo="body" optionValue="id" selectedItemsLabel="{0} sel." [maxSelectedLabels]="1" >
                    </p-multiSelect>
				</th>
				<th style="width: 150px;">
						<input style="width: 120px;" pInputText type="text" (input)="dt.filter($event.target.value,'BarCode', 'contains')" placeholder="Filtrer par EAN" />
				</th>
				<th style="width: 200px;">
						<span class="p-input-icon-left">
							<i class="pi pi-search"></i>
							<input style="width: 150px;" pInputText type="text" (input)="dt.filter($event.target.value,'Id', 'contains')" placeholder="Filtrer par ref." />
						</span>
				</th>
				<th style="width: 250px;">

					<span class="p-input-icon-left">
						<i class="pi pi-search"></i>
						<input style="width: 200px;" pInputText type="text" (input)="dt.filter($event.target.value,'name', 'contains')" placeholder="Filtrer par nom" />
					</span>

				</th>
				<th>
                    
				</th>
				<th style="width: 100px;"></th>
				<th style="width: 100px;"></th>
				<th style="width: 100px;"></th>
				<th *ngIf="api.adminOrder"></th>
				<th *ngIf="api.adminOrder"></th>
				<th style="width: 130px"></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-rowgroup="rowgroup" let-rowspan="rowspan">
			<tr class="{{row.qtyInCart > 0 ? 'p-highlight' : ''}}" [ngClass]="{'bg-red-700':row.rupture, 'bg-yellow-400':row.offer_name}">
				<td *ngIf="rowgroup" [attr.rowspan]="rowspan">
					{{row.offer_name ? row.offer_name : row.name_editor}}
				</td>
				<td style="width: 150px;">{{row.BarCode}}</td>
				<td style="width: 200px;">{{row.Id}}</td>
				<td style="width: 250px;">{{row.name}}</td>
				<td >
					<img class="logo-editor" src="https://blackrockgames.fr/upload/editor/350_{{row.logo_editor}}" pTooltip="{{row.name_editor}}">	
				</td>
				<td style="width: 100px;">{{row.priceHT | currency:'EUR'}}</td>
				<td style="width: 100px;">{{row.discountAmount ? row.priceHT - row.discountAmount : row.priceHT - (row.priceHT * row.discountRate/100) | currency:'EUR'}}</td>
				<td style="width: 100px;">{{row.Rate}}</td>
				<td *ngIf="api.adminOrder">{{row.RealStock | number:'1.0-0'}}</td>
				<td *ngIf="api.adminOrder">{{row.NumberOfItemByPackage | number:'1.0-0'}}</td>
				<td style="width: 130px" class="text-center">
					<div >
						<p-inputNumber [step]="row.step" (onInput)="changeQty($event,row)" (onBlur)="api.roundToStep(row, 'qtyInCart')" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" inputStyleClass="w-3rem text-center py-1 px-1 border-transparent" [(ngModel)]="row.qtyInCart"
				class="border-1 surface-border border-round" decrementButtonClass="p-button-warning py-1 px-1" incrementButtonClass="p-button-success py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>



